import React, { useState } from 'react';
import './TrainingDomains.css';
import CustomisedForm from '../CustomisedForm/CustomisedForm';
import aiRaspberry from '../../assets/ai-raspberry.jpg';
import printing3d from '../../assets/3d-printing.jpg';

const getCourses = (duration) => [
  {
    category: 'Age 6 & 7 · Little Innovator',
    categoryIcon: '🌟',
    title: 'Little Innovator 1',
    duration: duration,
    desc: 'A fun, play-based introduction to technology for children aged 6 & 7. Children explore basic concepts of electricity, light, magnets, and simple circuits through colourful hands-on activities.',
    tags: ['Age 6 & 7', 'Module 1', 'Play-Based Learning', 'Grade 1–2'],
    img: 'https://images.unsplash.com/photo-1503676260728-1c00da094a0b?w=600&q=80',
    filter: ['All Courses', 'Age 6 & 7'],
  },
  {
    category: 'Age 6 & 7 · Little Innovator',
    categoryIcon: '🌟',
    title: 'Little Innovator 2',
    duration: duration,
    desc: 'Building on Module 1, children aged 6 & 7 discover how everyday gadgets work through guided experiments with motors, buzzers, and basic sensors.',
    tags: ['Age 6 & 7', 'Module 2', 'Curiosity & Exploration', 'Grade 1–2'],
    img: 'https://images.unsplash.com/photo-1560785496-3c9d27877182?w=600&q=80',
    filter: ['All Courses', 'Age 6 & 7'],
  },
  {
    category: 'Foundational',
    categoryIcon: '⚡',
    title: 'Electronics',
    duration: duration,
    desc: 'Learn the fundamentals of basic electronics through hands-on activities with resistors, capacitors, LEDs, diodes, switches, and circuits, building a strong foundation in electronic concepts and practical hardware skills.',
    tags: ['Breadboard & Jumpers', 'Multimeter', 'Soldering Tools', 'LEDs & Resistors'],
    img: 'https://images.unsplash.com/photo-1518770660439-4636190af475?w=600&q=80',
    filter: ['All Courses', 'Age 8+', 'Foundational'],
  },
  {
    category: 'Foundational',
    categoryIcon: '⚡',
    title: 'Embedded Systems',
    duration: duration,
    desc: 'Learn microcontroller programming with Arduino by working on real-time embedded projects using GPIO, PWM, ADC, sensors, and communication modules, while building practical automation and control systems.',
    tags: ['Arduino', 'C Programming', 'Sensors & Modules'],
    img: 'https://images.unsplash.com/photo-1553406830-ef2513450d76?w=600&q=80',
    filter: ['All Courses', 'Age 8+', 'Foundational'],
  },
  {
    category: 'Foundational',
    categoryIcon: '⚡',
    title: 'IoT',
    duration: duration,
    desc: 'Learn to connect and control smart devices using ESP32, Wi-Fi, and MQTT protocols while building real-time IoT projects such as home automation and remote monitoring systems.',
    tags: ['ESP8266/ESP32', 'Wi-Fi & Bluetooth', 'Blynk Cloud', 'MQTT'],
    img: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=600&q=80',
    filter: ['All Courses', 'Age 8+', 'Foundational'],
  },
  {
    category: 'Foundational',
    categoryIcon: '⚡',
    title: 'Robotics',
    duration: duration,
    desc: 'Learn to design, build, and program intelligent systems using motors, sensors, and controllers while exploring automation, gesture control, Bluetooth communication, and voice-controlled technologies through hands-on projects.',
    tags: ['Servo & DC Motors', 'IR & Ultrasonic Sensors', 'Bluetooth'],
    img: 'https://images.unsplash.com/photo-1485827404703-89b55fcc595e?w=600&q=80',
    filter: ['All Courses', 'Age 8+', 'Foundational'],
  },
  
  {
    category: 'Advanced Level',
    categoryIcon: '🚀',
    title: 'Artificial Intelligence with Raspberry Pi',
    duration: duration,
    desc: 'Learn the fundamentals of Artificial Intelligence with a focus on deep learning, neural networks, and computer vision using Python and TensorFlow.',
    tags: ['Artificial Intelligence', 'Deep Learning', 'Neural Networks', 'Python', 'TensorFlow'],
    img: aiRaspberry,
    filter: ['All Courses', 'Age 8+', 'Advanced Level'],
  },
  {
    category: 'Advanced Level',
    categoryIcon: '🚀',
    title: 'Drone Technology',
    duration: duration,
    desc: 'Learn the fundamentals of drone technology through hands-on training in drone assembly, flight control systems, ESCs, BLDC motors, calibration, and flight operations.',
    tags: ['Flight Controllers', 'BLDC Motors & ESCs', 'GPS & Sensors'],
    img: 'https://images.unsplash.com/photo-1473968512647-3e447244af8f?w=600&q=80',
    filter: ['All Courses', 'Age 8+', 'Advanced Level'],
  },
  {
    category: 'Advanced Level',
    categoryIcon: '🚀',
    title: 'AI & Tiny ML',
    duration: duration,
    desc: 'Learn the fundamentals of Artificial Intelligence and TinyML by developing and deploying machine learning models on microcontrollers for real-time applications.',
    tags: ['TinyML & Edge AI', 'Machine Learning', 'Microcontrollers'],
    img: 'https://images.unsplash.com/photo-1677442136019-21780ecad995?w=600&q=80',
    filter: ['All Courses', 'Age 8+', 'Advanced Level'],
  },
  {
    category: 'Advanced Level',
    categoryIcon: '🚀',
    title: '3D Design & Printing',
    duration: duration,
    desc: 'Learn 2D & 3D designing using AutoCAD, Fusion 360, and Blender to create product designs, enclosures, and prototypes.',
    tags: ['AutoCAD', 'Fusion 360', 'Blender'],
    img: printing3d,
    filter: ['All Courses', 'Age 8+', 'Advanced Level'],
  },
  {
    category: 'Advanced Level',
    categoryIcon: '🚀',
    title: 'Mechatronics',
    duration: duration,
    desc: 'Learn the integration of mechanical, electrical, and software systems to design and build intelligent automated systems.',
    tags: ['Mechatronics Systems', 'Sensors & Actuators', 'Motor Control', 'Automation Systems'],
    img: 'https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?w=600&q=80',
    filter: ['All Courses', 'Age 8+', 'Advanced Level'],
  },
  {
    category: 'Flexible',
    categoryIcon: '✨',
    title: 'Customised Learning Path',
    duration: 'On Request',
    desc: 'Create your own flexible learning journey by combining multiple technology domains based on your interest.',
    tags: ['Custom Learning Path', 'Multi-Domain Training', 'Flexible Duration', 'Personalized Curriculum'],
    img: 'https://images.unsplash.com/photo-1581092921461-eab62e97a780?w=600&q=80',
    filter: ['All Courses'],
    isCustom: true,
  },
];



const SCHOOL_FILTERS = ['All Courses', 'Age 6 & 7', 'Age 8+', 'Foundational', 'Advanced Level'];
const COLLEGE_FILTERS = ['All Courses', 'Foundational', 'Advanced Level'];

const getCollegeCourses = () => [
  {
    category: 'Foundational',
    categoryIcon: '⚡',
    title: 'Electronics',
    duration: '4 months',
    desc: 'Learn the fundamentals of basic electronics through hands-on activities with resistors, capacitors, LEDs, diodes, switches, and circuits, building a strong foundation in electronic concepts and practical hardware skills.',
    tags: ['Breadboard & Jumpers', 'Multimeter', 'Soldering Tools', 'LEDs & Resistors'],
    img: 'https://images.unsplash.com/photo-1518770660439-4636190af475?w=600&q=80',
    filter: ['All Courses', 'Foundational'],
  },
  {
    category: 'Foundational',
    categoryIcon: '⚡',
    title: 'Embedded Systems',
    duration: '4 months',
    desc: 'Learn microcontroller programming with Arduino by working on real-time embedded projects using GPIO, PWM, ADC, sensors, and communication modules, while building practical automation and control systems.',
    tags: ['Arduino', 'C Programming', 'Sensors & Modules'],
    img: 'https://images.unsplash.com/photo-1553406830-ef2513450d76?w=600&q=80',
    filter: ['All Courses', 'Foundational'],
  },
  {
    category: 'Foundational',
    categoryIcon: '⚡',
    title: 'IoT',
    duration: '4 months',
    desc: 'Learn to connect and control smart devices using ESP32, Wi-Fi, and MQTT protocols while building real-time IoT projects such as home automation and remote monitoring systems.',
    tags: ['ESP8266/ESP32', 'Wi-Fi & Bluetooth', 'Blynk Cloud', 'MQTT'],
    img: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=600&q=80',
    filter: ['All Courses', 'Foundational'],
  },
  {
    category: 'Foundational',
    categoryIcon: '⚡',
    title: 'Robotics',
    duration: '4 months',
    desc: 'Learn to design, build, and program intelligent systems using motors, sensors, and controllers while exploring automation, gesture control, Bluetooth communication, and voice-controlled technologies.',
    tags: ['Servo & DC Motors', 'IR & Ultrasonic Sensors', 'Bluetooth'],
    img: 'https://images.unsplash.com/photo-1485827404703-89b55fcc595e?w=600&q=80',
    filter: ['All Courses', 'Foundational'],
  },
  {
    category: 'Advanced Level',
    categoryIcon: '🚀',
    title: 'Drone Technology',
    duration: '4 months',
    desc: 'Learn the fundamentals of drone technology through hands-on training in drone assembly, flight control systems, ESCs, BLDC motors, calibration, and flight operations while building practical skills in aerial robotics and automation.',
    tags: ['Flight Controllers', 'BLDC Motors & ESCs', 'GPS & Sensors'],
    img: 'https://images.unsplash.com/photo-1473968512647-3e447244af8f?w=600&q=80',
    filter: ['All Courses', 'Advanced Level'],
  },
  {
    category: 'Advanced Level',
    categoryIcon: '🚀',
    title: 'AI & Tiny ML',
    duration: '4 months',
    desc: 'Learn the fundamentals of Artificial Intelligence and TinyML by developing and deploying machine learning models on microcontrollers for real-time applications such as voice detection, gesture recognition, and smart edge-based systems.',
    tags: ['TinyML & Edge AI', 'Machine Learning', 'Microcontrollers'],
    img: 'https://images.unsplash.com/photo-1677442136019-21780ecad995?w=600&q=80',
    filter: ['All Courses', 'Advanced Level'],
  },
  {
    category: 'Advanced Level',
    categoryIcon: '🚀',
    title: '3D Design & Printing',
    duration: '4 months',
    desc: 'Learn 2D & 3D designing using AutoCAD, Fusion 360, and Blender to create product designs, enclosures, and prototypes while gaining hands-on experience in 3D modeling and printing workflows.',
    tags: ['AutoCAD', 'Fusion 360', 'Blender'],
    img: printing3d,
    filter: ['All Courses', 'Advanced Level'],
  },
  {
    category: 'Advanced Level',
    categoryIcon: '🚀',
    title: 'Mechatronics',
    duration: '4 months',
    desc: 'Learn the integration of mechanical, electrical, and software systems to design and build intelligent automated systems, smart actuators, and robotic mechanisms through hands-on engineering projects.',
    tags: ['Mechatronics Systems', 'Sensors & Actuators', 'Motor Control', 'Automation Systems'],
    img: 'https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?w=600&q=80',
    filter: ['All Courses', 'Advanced Level'],
  },
  {
    category: 'Advanced Level',
    categoryIcon: '🚀',
    title: 'STM32 Microcontroller',
    duration: '4 months',
    desc: 'Learn advanced embedded system development using STM32 ARM Cortex-M microcontrollers, focusing on HAL libraries, timers, interrupts, DMA, and RTOS basics while building efficient real-time applications and control systems.',
    tags: ['STM32 Microcontrollers', 'ARM Cortex-M', 'Embedded C', 'HAL Libraries', 'GPIO & ADC'],
    img: 'https://images.unsplash.com/photo-1517420704952-d9f39e95b43e?w=600&q=80',
    filter: ['All Courses', 'Advanced Level'],
  },
  {
    category: 'Advanced Level',
    categoryIcon: '🚀',
    title: 'AI (Artificial Intelligence)',
    duration: '6 months',
    desc: 'Learn the fundamentals of Artificial Intelligence with a focus on deep learning, neural networks, and computer vision using Python and TensorFlow, along with hands-on deployment of AI models on edge devices like Raspberry Pi.',
    tags: ['Artificial Intelligence', 'Deep Learning', 'Neural Networks', 'Python', 'TensorFlow'],
    img: 'https://images.unsplash.com/photo-1531746790731-6c087fecd65a?w=600&q=80',
    filter: ['All Courses', 'Advanced Level'],
  },
  {
    category: 'Advanced Level 2',
    categoryIcon: '⭐',
    title: 'ROS / ROS2',
    duration: '6 months',
    desc: 'Learn Robot Operating System (ROS/ROS2) for building intelligent robotic systems with a focus on SLAM, autonomous navigation, and multi-robot coordination. Gain hands-on experience in developing, simulating, and controlling robots for real-world applications.',
    tags: ['ROS', 'ROS2', 'SLAM', 'Autonomous Navigation', 'Path Planning'],
    img: 'https://images.unsplash.com/photo-1485827404703-89b55fcc595e?w=600&q=80',
    filter: ['All Courses', 'Advanced Level'],
    isAdvanced2: true,
  },
  {
    category: 'Flexible',
    categoryIcon: '✨',
    title: 'Customised Learning Path',
    duration: 'On Request',
    desc: 'Create your own flexible learning journey by combining multiple technology domains based on your interest. Choose courses, set your preferred duration, and add specializations or custom topics to build a personalized skill development program tailored to your goals.',
    tags: ['Custom Learning Path', 'Multi-Domain Training', 'Flexible Duration', 'Personalized Curriculum'],
    img: 'https://images.unsplash.com/photo-1581092921461-eab62e97a780?w=600&q=80',
    filter: ['All Courses'],
    isCustom: true,
  },
];

const getWorkshopCourses = () => [
  {
    category: 'Foundational',
    categoryIcon: '⚡',
    title: 'Embedded Systems',
    duration: '3–5 Days',
    desc: 'Learn microcontroller programming with Arduino by working on real-time embedded projects using GPIO, PWM, ADC, sensors, and communication modules, while building practical automation and control systems.',
    tags: ['Arduino', 'C Programming', 'Sensors & Modules'],
    img: 'https://images.unsplash.com/photo-1553406830-ef2513450d76?w=600&q=80',
    filter: ['All Courses', 'Foundational'],
  },
  {
    category: 'Foundational',
    categoryIcon: '⚡',
    title: 'IoT',
    duration: '3–5 Days',
    desc: 'Learn to connect and control smart devices using ESP32, Wi-Fi, and MQTT protocols while building real-time IoT projects such as home automation and remote monitoring systems.',
    tags: ['ESP8266/ESP32', 'Wi-Fi & Bluetooth', 'Blynk Cloud', 'MQTT'],
    img: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=600&q=80',
    filter: ['All Courses', 'Foundational'],
  },
];

const getAdvancedWorkshopCourses = () => [
  {
    category: 'Advanced Level',
    categoryIcon: '🚀',
    title: 'Drone Technology',
    duration: '3–5 Days',
    desc: 'Learn the fundamentals of drone technology through hands-on training in drone assembly, flight control systems, ESCs, BLDC motors, calibration, and flight operations while building practical skills in aerial robotics and automation.',
    tags: ['Flight Controllers', 'BLDC Motors & ESCs', 'GPS & Sensors'],
    img: 'https://images.unsplash.com/photo-1473968512647-3e447244af8f?w=600&q=80',
    filter: ['All Courses', 'Advanced Level'],
  },
  {
    category: 'Advanced Level',
    categoryIcon: '🚀',
    title: 'Mechatronics',
    duration: '3–5 Days',
    desc: 'Learn the integration of mechanical, electrical, and software systems to design and build intelligent automated systems, smart actuators, and robotic mechanisms through hands-on engineering projects.',
    tags: ['Mechatronics Systems', 'Sensors & Actuators', 'Motor Control', 'Automation Systems'],
    img: 'https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?w=600&q=80',
    filter: ['All Courses', 'Advanced Level'],
  },
  {
    category: 'Advanced Level',
    categoryIcon: '🚀',
    title: 'Artificial Intelligence with Raspberry Pi',
    duration: '3–5 Days',
    desc: 'Learn the fundamentals of Artificial Intelligence with a focus on deep learning, neural networks, and computer vision using Python and TensorFlow, along with hands-on deployment on Raspberry Pi.',
    tags: ['Artificial Intelligence', 'Deep Learning', 'Neural Networks', 'Python', 'TensorFlow'],
    img: aiRaspberry,
    filter: ['All Courses', 'Advanced Level'],
  },
];

const getVACCourses = () => [
  {
    category: 'Innovators Programme',
    categoryIcon: '🌟',
    title: 'Innovation Engineers',
    duration: 'Custom timeline',
    desc: 'A comprehensive programme combining key contents from all foundational courses — Electronics, Embedded Systems, IoT, and Robotics — into one integrated learning journey focused on building complete real-world projects.',
    tags: ['Electronics', 'Embedded Systems', 'IoT', 'Robotics', 'Multi-Domain'],
    img: 'https://images.unsplash.com/photo-1581092921461-eab62e97a780?w=600&q=80',
    filter: ['All Courses'],
  },
  {
    category: 'Advanced Level',
    categoryIcon: '🚀',
    title: 'Drone Technology',
    duration: 'Custom timeline',
    desc: 'Learn drone assembly, flight control systems, ESCs, BLDC motors, calibration, and flight operations while building practical skills in aerial robotics and automation.',
    tags: ['Flight Controllers', 'BLDC Motors & ESCs', 'GPS & Sensors'],
    img: 'https://images.unsplash.com/photo-1473968512647-3e447244af8f?w=600&q=80',
    filter: ['All Courses'],
  },
  {
    category: 'Advanced Level',
    categoryIcon: '🚀',
    title: 'Mechatronics',
    duration: 'Custom timeline',
    desc: 'Learn the integration of mechanical, electrical, and software systems to design and build intelligent automated systems, smart actuators, and robotic mechanisms.',
    tags: ['Mechatronics Systems', 'Sensors & Actuators', 'Motor Control', 'Automation Systems'],
    img: 'https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?w=600&q=80',
    filter: ['All Courses'],
  },
  {
    category: 'Advanced Level',
    categoryIcon: '🚀',
    title: 'Artificial Intelligence with Raspberry Pi',
    duration: 'Custom timeline',
    desc: 'Learn the fundamentals of Artificial Intelligence with deep learning, neural networks, and computer vision using Python and TensorFlow with hands-on deployment on Raspberry Pi.',
    tags: ['Artificial Intelligence', 'Deep Learning', 'Python', 'TensorFlow'],
    img: aiRaspberry,
    filter: ['All Courses'],
  },
  {
    category: 'Advanced Level',
    categoryIcon: '🚀',
    title: 'STM32 Microcontroller',
    duration: 'Custom timeline',
    desc: 'Learn advanced embedded system development using STM32 ARM Cortex-M microcontrollers, focusing on HAL libraries, timers, interrupts, DMA, and RTOS basics.',
    tags: ['STM32 Microcontrollers', 'ARM Cortex-M', 'Embedded C', 'HAL Libraries'],
    img: 'https://images.unsplash.com/photo-1517420704952-d9f39e95b43e?w=600&q=80',
    filter: ['All Courses'],
  },
  {
    category: 'Advanced Level',
    categoryIcon: '🚀',
    title: 'AI (Artificial Intelligence)',
    duration: 'Custom timeline',
    desc: 'Learn AI fundamentals with deep learning, neural networks, and computer vision using Python and TensorFlow, along with hands-on deployment on edge devices.',
    tags: ['Artificial Intelligence', 'Deep Learning', 'Neural Networks', 'Python', 'TensorFlow'],
    img: 'https://images.unsplash.com/photo-1677442136019-21780ecad995?w=600&q=80',
    filter: ['All Courses'],
  },
  
];

const CONFIGS = {
  regular: {
    title: 'School Student - Regular Training Domains',
    subtitle: 'Foundational to advanced. Weekend sessions for school schedules.',
    stats: [
      { num: '11', label: 'Domains' },
      { num: '32 hrs', label: 'Per Domain' },
      { num: '5:1', label: 'Ratio' },
      { num: '✓', label: 'Certificate' },
    ],
    duration: '4 months',
  },
  intensive: {
  title: 'School Student - Holiday Intensive Domains',
  subtitle: 'A short-term intensive program designed for holidays, where students attend daily structured sessions with hands-on activities and guided practice.',
  stats: [
    { num: '11', label: 'Domains' },
    { num: '30 hrs', label: 'Per Domain' },
    { num: '5:1', label: 'Ratio' },
    { num: '✓', label: 'Certificate' },
  ],
  duration: '15 days',
},
  camp: {
    title: 'School Student - Camp Domains',
    subtitle: 'A 10-days interactive learning camp for students to explore Electronics, IoT, and Robotics through engaging, project-based activities.',
    stats: [
      { num: '11', label: 'Domains' },
      { num: '21 hrs', label: 'Per Domain' },
      { num: '5:1', label: 'Ratio' },
      { num: '✓', label: 'Certificate' },
    ],
    duration: '7 days',
  },
  college: {
  title: 'College Student - Regular Training Domains',
  subtitle: 'All 14 domains including STM32, AI & ROS. Weekend batches across 4-6 months.',
  stats: [
    { num: '11', label: 'Domains' },
    { num: '32 hrs', label: 'Per Domain' },
    { num: '5:1', label: 'Ratio' },
    { num: '✓', label: 'Certificate' },
  ],
  duration: '4 months',
},
workshop: {
  title: 'Regular Workshop — Embedded & IoT Domains',
  subtitle: 'Hands-on workshop conducted at your campus. 3–5 days intensive. Minimum 60 students per batch.',
  stats: [
    { num: '2', label: 'Domains' },
    { num: '30 hrs', label: 'Total Hours' },
    { num: '60:1', label: 'Ratio' },
    { num: '✓', label: 'Certificate' },
  ],
  duration: '3–5 Days',
},
advanced_workshop: {
  title: 'Advanced Workshop — Drone, Mechatronics & AI+RPI Domains',
  subtitle: 'Advanced hands-on workshop conducted at your campus. 3–5 days intensive. Minimum 60 students per batch.',
  stats: [
    { num: '3', label: 'Domains' },
    { num: '30 hrs', label: 'Total Hours' },
    { num: '60:1', label: 'Ratio' },
    { num: '✓', label: 'Certificate' },
  ],
  duration: '3–5 Days',
},
vac: {
  title: 'Value Added Courses — Specialisation Domains',
  subtitle: 'Semester-long industry-focused skill development programs. Minimum 60 students per batch.',
  stats: [
    { num: '6', label: 'Domains' },
    { num: '30 hrs', label: 'Per Domain' },
    { num: '60:1', label: 'Ratio' },
    { num: '✓', label: 'Certificate' },
  ],
  duration: 'Custom timeline',
},
};

function TrainingDomains({ onClose, onMoreDetails, type = 'regular' }) {
  const [activeFilter, setActiveFilter] = useState('All Courses');
  const [showCustomForm, setShowCustomForm] = useState(false);
  const config = CONFIGS[type];
  const isCollege = type === 'college' || type === 'workshop' || type === 'advanced_workshop';
const FILTERS = (type === 'workshop' || type === 'advanced_workshop' || type === 'vac')
  ? ['All Courses']
  : isCollege
    ? COLLEGE_FILTERS
    : SCHOOL_FILTERS;
const COURSES = type === 'workshop'
  ? getWorkshopCourses()
  : type === 'advanced_workshop'
    ? getAdvancedWorkshopCourses()
    : type === 'vac'
      ? getVACCourses()
      : (isCollege ? getCollegeCourses() : getCourses(config.duration));
  const filtered = COURSES.filter((c) => c.filter.includes(activeFilter));

  return (
    <div className="td__wrapper">
      <div className="td__inner">

        {/* Close */}
        <button className="td__close" onClick={onClose}>✕ Close</button>

        {/* Header */}
        <div className="td__header">
          <div className="td__header-left">
            <h2 className="td__title">{config.title}</h2>
            <p className="td__subtitle">{config.subtitle}</p>
          </div>
          <div className="td__stats">
            {config.stats.map((s, i) => (
              <div key={i} className="td__stat">
                <span className="td__stat-num">{s.num}</span>
                <span className="td__stat-label">{s.label}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Filter Tabs */}
        <div className="td__filters">
          {FILTERS.map((f, i) => (
            <button
              key={i}
              className={`td__filter ${activeFilter === f ? 'td__filter--active' : ''}`}
              onClick={() => setActiveFilter(f)}
            >
              {f === 'Age 6 & 7' && <span className="td__filter-dot td__filter-dot--yellow"></span>}
              {f === 'Age 8+' && <span className="td__filter-dot td__filter-dot--green"></span>}
              {f === 'Foundational' && <span className="td__filter-dot td__filter-dot--blue"></span>}
              {f === 'Advanced Level' && <span className="td__filter-dot td__filter-dot--blue"></span>}
              {f}
              {f === 'Age 6 & 7' && <span className="td__filter-new">NEW</span>}
            </button>
          ))}
        </div>

        {/* Course Grid */}
        <div className="td__grid">
          {filtered.map((course, i) => (
            <div key={i} className={`td__card ${course.isCustom ? 'td__card--custom' : ''}`}>
              <img src={course.img} alt={course.title} className="td__card-img" />
              <div className="td__card-body">
                <div className="td__card-top">
                  <span className={`td__card-category ${course.isAdvanced2 ? 'td__card-category--advanced2' : ''}`}>
  {course.categoryIcon} {course.category}
</span>
                </div>
                <div className="td__card-title-row">
                  <h3 className="td__card-title">{course.title}</h3>
                  <span className={`td__card-duration ${course.isAdvanced2 ? 'td__card-duration--highlight' : ''}`}>
  {course.duration}
</span>
                </div>
                <p className="td__card-desc">{course.desc}</p>
                <div className="td__card-tags">
                  {course.tags.map((t, j) => (
                    <span key={j} className="td__card-tag">{t}</span>
                  ))}
                </div>
                <button
  className="td__card-btn"
  onClick={() => {
    if (course.title === 'Customised Learning Path') {
      setShowCustomForm(true);
    } else {
      onMoreDetails(course.title);
    }
  }}
>
  → More Details
</button>
              </div>
            </div>
          ))}
        </div>
        {/* Customised Form Popup */}
        {showCustomForm && (
  <CustomisedForm
    onClose={() => setShowCustomForm(false)}
    isCollege={isCollege}
  />
)}

      </div>
    </div>
    
  );
}

export default TrainingDomains;